import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils/cn';

/** Accessible loading indicator. Render alongside a visually-hidden label. */
export function Spinner({ className }: { className?: string }) {
  return (
    <span role="status" aria-live="polite" className={cn('inline-flex items-center', className)}>
      <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" />
      <span className="sr-only">Loading…</span>
    </span>
  );
}
